import { render } from "./Bottom.vue?vue&type=template&id=214ac161&scoped=true"
import script from "./Bottom.vue?vue&type=script&lang=js"
export * from "./Bottom.vue?vue&type=script&lang=js"

import "./Bottom.vue?vue&type=style&index=0&id=214ac161&lang=scss&scoped=true"

import exportComponent from "D:\\兼职\\vue_jhdl\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214ac161"]])

export default __exports__